import React from "react";

import { type Place } from "@xapp/components";

import classes from "./style.scss";

/**
 * Get the header for the current step
 */
export function getStepHeader(step: string, place?: Place, params?: URLSearchParams): React.ReactNode | undefined {
    // const partner = params?.get("partner") || "";
    const header1 = params?.get("header1") || "";

    switch (step) {
        case "intent":
            return <span className={classes.hideMobile}>Welcome!</span>;
        case "business_info":
            if (header1) {
                return <span>{header1}</span>;
            } else {
                return <span>Tell us about your Business</span>;
            }
        case "find_confirm_profile":
            return <span>Confirm your Business</span>;
        case "find_profile":
        case "confirm_profile":
            return (
                <span>
                    Train your <span style={{ color: "#1aa7dc" }}>AI Agent</span>{" "}
                    <span style={{ color: "gray" }}>to Book Jobs & Capture Leads</span>
                </span>
            );
        case "use_website":
            return (
                <span>
                    Train your <span style={{ color: "#1aa7dc" }}>AI Agent</span> with your website
                </span>
            );
        case "training":
            return (
                <span>
                    Training <span style={{ color: "#1aa7dc" }}>AI Agent</span>
                </span>
            );
        case "claim_agent":
            //change depending on if we have a place or not
            if (place) {
                return (
                    <span>
                        {place?.name}'s <span style={{ color: "#1aa7dc" }}>AI Agent</span> Powers Google Book Online
                    </span>
                );
            } else {
                return (
                    <span>
                        Claim your <span style={{ color: "#1aa7dc" }}>AI Agent</span>
                    </span>
                );
            }
        // case "sign_up":
        //     return <span>Let's save your progress, please create an account.</span>;
        case "checkout":
            return <span>No Additional Cost Per Lead</span>;
        default:
            return undefined;
    }
}

/**
 * Get the aside content for the current step
 */
export function getStepAside(step: string, place?: Place, params?: URLSearchParams): React.ReactNode | undefined {
    // const partner = params?.get("partner") || "";

    const bullet1 = params?.get("bullet1") || "";
    const bullet2 = params?.get("bullet2") || "";
    const bullet3 = params?.get("bullet3") || "";

    switch (step) {
        case "intent":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>We can help you book more potential business</b>
                    </li>
                    <li>Simplified booking and lead capture powered by AI help capture more leads</li>
                    <li>Capture leads directly on your Google Business Profile from Google Search & Maps</li>
                </ul>
            );
        case "find_profile":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Find your profile </b> by entering your business name
                    </li>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile and on
                        your website if you have one
                    </li>
                    <li>Takes less than a minute!</li>
                </ul>
            );
        case "business_info":
            return (
                <ul className={classes.asideList}>
                    <li>
                        {bullet1 ? (
                            <>{bullet1}</>
                        ) : (
                            <>
                                <b>Tell us about your business </b> to help us find your profile
                            </>
                        )}
                    </li>
                    <li>
                        {bullet2 ? (
                            <>{bullet2}</>
                        ) : (
                            <>
                                Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile
                                and on your website if you have one
                            </>
                        )}
                    </li>
                    <li>{bullet3 ? <>{bullet3}</> : <>Takes less than a minute!</>}</li>
                </ul>
            );
        case "advanced_search":
            return (
                <ul className={classes.asideList}>
                    <li>Let's try to find your profile it with more information</li>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile and on
                        your website if you have one
                    </li>
                    <li>If we still can't find it, we can still proceed</li>
                </ul>
            );
        case "confirm_profile":
            return (
                <ul className={classes.asideList}>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile and on
                        your website if you have one
                    </li>
                    <li>Takes less than a minute!</li>
                </ul>
            );
        case "use_website":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Enter your website </b> to train your <span style={{ color: "#1aa7dc" }}>AI Agent</span>
                    </li>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile and on
                        your website if you have one
                    </li>
                    <li>Takes less than a minute!</li>
                </ul>
            );
        case "training":
            return (
                <ul className={classes.asideList}>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI Agent</span> is being trained
                    </li>
                    <li>Initial training takes just a few seconds.</li>
                </ul>
            );
        case "claim_agent":
            if (place) {
                return (
                    <ul className={classes.asideList}>
                        <li>
                            Your <span style={{ color: "#1aa7dc" }}>AI agent</span> was trained on your data
                        </li>
                        <li>
                            Adds <span style={{ color: "#1aa7dc" }}>Book Online</span> to your Google Business Profile
                        </li>
                        <li>
                            <b>Claim your AI Agent</b> to book jobs directly from your Google Business Profile and
                            Google Maps
                        </li>
                    </ul>
                );
            } else {
                return (
                    <ul className={classes.asideList}>
                        <li>
                            Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your data.
                        </li>
                        <li>Your agent will power website bookings and lead capture</li>
                        <li>Install on your website or use our customizable hosted page</li>
                    </ul>
                );
            }
        case "sign_up":
            return (
                <ul className={classes.asideList}>
                    <li>Sign up to claim your AI Agent for your Google Business Profile</li>
                    <li>Expect the Book Online button to appear within 48 hours</li>
                    <li>Your credentials & email will be used to verify you are related to the business</li>
                </ul>
            );
        default:
            return undefined;
    }
}
